<template>
    <div class="editor m-3">
        <img class="theme-svg" src="../../../../public/icons/workflow/close.svg" id="close" @click="Cancel" />
        <span class="title">Set parameter values</span>
        <div class="child-editor" v-for="param, i in CurrentParameters.parameters">
            <label>{{param.name}}</label>
            <FormParameterEditor :param="param" @update="param.currentValue = $event;" />
        </div>
        <div style="margin:0 auto;">
            <CommonButton
                :type="ButtonType.Primary"
                :isDanger="true"
                :text="Localizer.Localize('Cancel_PascalCase')"
                @click="Cancel"/>
            <CommonButton
                :type="ButtonType.Primary"
                :text="Localizer.Localize('Run_PascalCase')"
                @click="Run"/>
        </div>
    </div>
</template>

<script lang="ts">
    require('@/assets/portal.css');

    import { Component, Prop, Vue } from 'vue-facing-decorator';
    import Spinner from "../../helpers/Spinner.vue";
    import Empty from "../../helpers/Empty.vue";
    import * as api from "../../../api/ApiClient";

    import FormParameterEditor from "../forms/FormParameterEditor.vue";
    import CommonButton from '../../helpers/CommonButton.vue';
    import { ButtonType } from '../../helpers/HelpersInterface';
    import { Localizer } from '../../../api/Localizer';

    @Component({ components: { Spinner, Empty, FormParameterEditor, CommonButton } })
    export default class FormParameterInput extends Vue {
        @Prop() Parameters!: api.FormParameterList;
        private Localizer = new Localizer(this.$store);
        private ButtonType = ButtonType;


        CurrentParameters: api.FormParameterList = new api.FormParameterList;
        SelectedParameters: api.FormParameterCurrentValue[] | null = [];
        beforeMount() {
            var copy = this.Parameters.toJSON();
            this.CurrentParameters = api.FormParameterList.fromJS(copy);
        }

        async mounted() {

        }

        Cancel() {
            this.$nextTick().then(() => {
                this.SelectedParameters = null;
            });
            this.$emit('Cancel');
        }

        Run() {
            this.$nextTick().then(() => {
                if (this.CurrentParameters.parameters) {
                    this.SelectedParameters = this.CurrentParameters.parameters.map(param => new api.FormParameterCurrentValue({
                        name: param.name,
                        currentValue: param.currentValue,
                        isPinned: false
                    }));
                }
                if (this.SelectedParameters && this.SelectedParameters.length > 0) {
                    this.$store.commit("excel/SetSelectedParameters", this.SelectedParameters);
                    this.$emit('Run');
                }
            });
        }
    }
</script>

<style scoped>
    .editor {
        background-color: var(--background-primary);
    }

    label {
        font-weight: bold;
        margin-top: 6px;
    }

    select {
        border-radius: 3px 3px;
        padding: 5px;
    }

    #close {
        float: right;
    }

    .title {
        font-size: 22px;
        font-weight: bold;
    }
</style>
